export default "__VITE_ASSET__DSuMZjOE__"